import React from "react";
import Title from "./common/Title";
import AvatarCard from "./common/AvatarCard";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import TeamList from "./common/partnerList"; // This is data mockup and it will be deleted after provided with real data

const useStyles = makeStyles((theme) => ({
  wrapper: {
    borderWidth: "2px 0 0 2px",
    borderStyle: "solid",
    borderColor: theme.palette.secondary.main,
  },
  teamItem: {
    borderWidth: "0 2px 2px 0",
    borderStyle: "solid",
    borderColor: theme.palette.secondary.main,
    width: "100%",
  },
}));

export default function Team() {
  const classes = useStyles();
  return (
    <>
      <Title
        title="Our Team"
        description="Meet the people behind NaTakallam!"
      />
      <Box px={5}>
        <Grid
          container
          className={classes.wrapper}
          spacing={0}
          justify="center"
          alignItems="center"
        >
          {TeamList.slice(0, 6).map((team, index) => (
            <Grid item sm={6} md={4} key={index} className={classes.teamItem}>
              <Box py={6} px={2}>
                <AvatarCard {...team} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}
